import { render, staticRenderFns } from "./LinkHero.vue?vue&type=template&id=701f9cc2&scoped=true"
import script from "./LinkHero.vue?vue&type=script&lang=js"
export * from "./LinkHero.vue?vue&type=script&lang=js"
import style0 from "./LinkHero.vue?vue&type=style&index=0&id=701f9cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701f9cc2",
  null
  
)

export default component.exports